import { useContext } from 'react';
import { EntityTypeID, Filter, WorkflowType } from '@fabric-ui/components';
import { FileFormat } from '@fabric-ui/components/Table';
import { useMutation } from '@tanstack/react-query';
import { QueryObject } from '@views/CustomDashboards/types';
import { gql } from 'graphql-request';
import { useAvContext } from '../context/AvContextProvider';
import { NotificationContext, WorkflowStatus } from '../context/AvSnackBarProvider';
import { PresignedUrlType, usePresignedUrl } from './usePresignedURL';

export const EXPORT_QUERY_OBJECT = gql`
  query exportFromQueryObject($exportFromQueryDto: ExportFromQueryObjectInput!) {
    exportFromQueryObject(exportFromQueryObjectDto: $exportFromQueryDto) {
      runId
      wfId
    }
  }
`;

export const EXPORT_QUERY_SQL = gql`
  query exportFromQuerySql($exportFromQueryDto: ExportFromQuerySqlInput!) {
    exportFromQuerySql(exportFromQuerySqlDto: $exportFromQueryDto) {
      runId
      wfId
    }
  }
`;

export const useExportQueryObjectWorkflow = () => useExportQuery(EXPORT_QUERY_OBJECT);
export const useExportQuerySqlWorkflow = () => useExportQuery(EXPORT_QUERY_SQL);

export const useExportQuery = query => {
  const { api } = useAvContext();
  const { setRunInfo } = useContext(NotificationContext);
  const { mutate: getReportUrl } = usePresignedUrl(PresignedUrlType.QUERY);

  type QueryParameters = { querySql: string } | { queryObject: QueryObject };

  return useMutation({
    mutationFn: ({
      fileFormat = FileFormat.CSV_FORMAT,
      name,
      ...exportFromQueryDto
    }: { fileFormat?: string; projectionID?: EntityTypeID; contextFilter?: Filter; name?: string } & QueryParameters) =>
      api(query, {
        options: { exportFromQueryDto: { fileFormat, ...exportFromQueryDto, name } },
        onSuccess: ({ data }: { data: Record<string, any> }) => {
          setRunInfo({
            ...(data.exportFromQuerySql || data.exportFromQueryObject),
            workflowType: WorkflowType.ExportQuery,
            onSuccess: ({ status }) => {
              if (status === WorkflowStatus.COMPLETED) {
                getReportUrl({ wfId: Object.values(data)[0].wfId, runId: Object.values(data)[0].runId });
              }
            },
          });
        },
      }),
  });
};
